var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldShowBar
    ? _c(
        "div",
        { staticClass: "row no-gutters justify-content-center pb-3 mt-3" },
        [
          _c("div", { staticClass: "col-12 text-center" }, [
            _c("span", [_vm._v(_vm._s(_vm.currentWidth))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 progress progress-styling rounded-pill" },
            [
              _c("div", {
                staticClass:
                  "progress-bar progress-bar lead-channel-primary-background-color rounded-pill",
                style: { width: _vm.currentWidth },
                attrs: {
                  role: "progressbar",
                  "aria-valuenow": _vm.loadingPercent,
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }
              })
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }